exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".region-card {\n  padding: 12px;\n  border: 1px solid #dbdbdb;\n  background-color: #fff;\n  margin: 12px;\n  width: 70vw;\n  height: 150px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  color: #5c626b;\n  font-size: 32px;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/less-loader/dist/cjs.js?{"javascriptEnabled":true}!./src/components/RegionCard/RegionCard.less
// module id = 872
// module chunks = 0